<form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <h1 class="headline-large">Sign In</h1>
  <mat-form-field class="login-field">
    <mat-label>Email</mat-label>
    <ng-container *ngIf="options && options.length > 0; else productionLogin">
      <input type="text" matInput aria-labelledby="Email" formControlName="email" [matAutocomplete]="auto" />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onSubmit()">
        <mat-option *ngFor="let option of filteredLogins | async" [value]="option" role="combobox">
          {{ option }}
        </mat-option>
      </mat-autocomplete>
      <div class="form__carrot"></div>
    </ng-container>
    <ng-template #productionLogin>
      <input type="text" aria-labelledby="Email" matInput formControlName="email" />
    </ng-template>
  </mat-form-field>
  <mat-error *ngIf="email.touched && email.invalid">{{ getErrorMessage() }}</mat-error>
  <mat-form-field class="login-field shift-right">
    <mat-label>Password</mat-label>
    <input
      [type]="inputType"
      id="password"
      matInput
      aria-labelledby="Password"
      formControlName="password"
      autocomplete="current-password"
    />

    <mat-icon
      matSuffix
      (click)="toggleVisibility()"
      [attr.aria-label]="visibilityLabel"
      tabindex="0"
      class="eye-icon"
      aria-hidden="false"
      >{{ visibilityIcon }}</mat-icon
    >
  </mat-form-field>
  <mat-error *ngIf="password.touched && password.invalid">{{ getErrorMessage() }}</mat-error>
  <mat-error *ngIf="invalidEmailPass"> Invalid email or password... </mat-error>
  <mat-error *ngIf="loginFailed && triesCount >= 3">
    Invalid email or password. Check the email address associated with your account for additional instructions.
  </mat-error>
  <button mat-flat-button aria-label="Sign in" #submitButton class="buttons" type="submit" color="primary" [isBusy]="isBusy" tabindex="0">
    Sign in
  </button>
  <a class="forget-password" routerLink="/auth/family/forgot-password">Forgot password?</a>
</form>
